<rt-evaluation-dropdown-header
  [heading]="'app.interview.how_to_evaluate_candidate' | translate"
  [canManageInterviewTemplates]="canManageInterviewTemplates()"
  [showBackButton]="showBackButton()"
  (back)="goBack.emit()"
/>

@if (loading()) {
  <div layout layout-justify-center padding-large>
    <rt-spinner />
  </div>
} @else {
  <div layout-vertical padding>
    @if (recommendedTemplate(); as recommended) {
      <rt-heading variant="subheading" margin-bottom-small-xx>
        {{ 'app.interview.add_evaluation_dropdown.groups.assigned_to_stage' | translate }}
      </rt-heading>
      <rt-evaluation-selection-item
        [icon]="'pin'"
        [heading]="recommended.label"
        [subheading]="
          'app.interview.add_evaluation_dropdown.recommended_selection_item.subheading' | translate
        "
        [recommended]="true"
        [truncateHeading]="true"
        (click)="goToRecommendedEvaluation.emit()"
        margin-bottom-small
      />
      <rt-heading variant="subheading" margin-bottom-small-xx>
        {{ 'app.interview.add_evaluation_dropdown.groups.other_forms' | translate }}
      </rt-heading>
    }
    <rt-evaluation-selection-item
      [icon]="'thumbs-up-down'"
      [heading]="
        'app.interview.add_evaluation_dropdown.quick_evaluation_selection_item.heading' | translate
      "
      [subheading]="
        'app.interview.add_evaluation_dropdown.quick_evaluation_selection_item.subheading'
          | translate
      "
      (click)="goToQuickEvaluation.emit()"
      margin-bottom-small-x
    />
    <rt-evaluation-selection-item
      [icon]="'border-color'"
      [heading]="
        'app.interview.add_evaluation_dropdown.evaluation_selection_item.heading' | translate
      "
      [subheading]="
        'app.interview.add_evaluation_dropdown.evaluation_selection_item.subheading' | translate
      "
      (click)="goToEvaluation.emit()"
    />
    @if (shouldShowScaleBanner) {
      <rt-feature-discovery-banner
        [title]="'app.interview.scale_banner.title' | translate"
        [description]="'app.interview.scale_banner.description' | translate"
        [ctaText]="'app.interview.scale_banner.cta' | translate"
        [variant]="'default'"
        [dismissible]="false"
        [textTemplate]="scaleBannerText"
        (ctaClick)="openEvaluationScaleSettings()"
        margin-top-small-x
      />
      <ng-template #scaleBannerText let-description="description" let-title="title">
        <rt-heading variant="heading">{{ title }}</rt-heading>
        <rt-heading variant="subheading dark normal">{{ description }}</rt-heading>
      </ng-template>
    }
  </div>
}
